import { Stack, StackProps, styled } from "@mui/material";

type IBannerInfo = {
  mandatory?: boolean;
  $isHover?: boolean;
}

export const BannerInfoContainer = styled(Stack)<StackProps & IBannerInfo>(({ theme, $isHover }) => ({
  ":hover": {
    background: `rgba(${theme.customColors.backgroundSecondaryHover})`,
    // background: theme.customColors.backgroundSecondaryHover, //TODO ripristinare
    cursor: "pointer"
  },
  background: $isHover ? `rgba(${theme.customColors.backgroundSecondaryHover})` : "transparent",
  // background: $isHover ? theme.customColors.backgroundSecondaryHover : "transparent", //TODO ripristinare
  borderRadius: "0.5rem",
  margin: "0 0.5rem"
}));

export const TypoContainer = styled(Stack)(() => ({
  alignItems: "center",
  background: "transparent",
  display: "flex",
  flexDirection: "row",
  flexGrow: 1,
  justifyContent: "space-between"
}));

export const BannerInfo = styled(Stack)<StackProps & IBannerInfo>(({ theme, mandatory }) => ({
  "&:before": {
    background: mandatory ? theme.customColors.textWarning : theme.customColors.systemSecondary01,
    content: "''",
    height: "1.75rem",
    marginLeft: "0.5rem",
    marginRight: "1rem",
    position: "relative",
    width: "0.125rem"
  },
  display: "flex",
  flexDirection: "row",
  padding: "0.5rem 0.5rem 0.5rem 0rem"
}));
